import { IDisplayColumn } from "../../interfaces/ManageView";
import { DisplayColumn } from "../../interfaces/ViewFolderResponse";

export const MapDisplayColumns = (displayColumns: DisplayColumn[]): IDisplayColumn[] => {
    if (!displayColumns) {
        return [];
    }
    return displayColumns.map((displayColumn: DisplayColumn) => ({
        internalName: displayColumn.InternalName,
        displayName: displayColumn.DisplayName,
        isDefault: displayColumn.IsDefault,
        customWidth: displayColumn.CustomWidth
    }));
};